import {
  Badge,
  Box,
  Center,
  Flex,
  HStack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { LocalVideoTrack } from 'agora-rtc-react'
import { CameraOff, MicOff, MicOn } from 'src/components/icon'

import { useLocalPlayer } from '../../context/localPlayerContext'
import { useVideoCallRoom } from '../../context/videoCallRoomContext'
import { SpeakerIndicator } from '../SpeakerIndicator/SpeakerIndicator'

type Props = {
  isSmall?: boolean
  hideBadge?: boolean
}

export const VideoCallRoomLocalPlayer: React.FC<Props> = ({
  isSmall = false,
  hideBadge = false,
}) => {
  const { roomStatus } = useVideoCallRoom()
  const {
    localMicrophoneTrack: audioTrack,
    localCameraTrack: cameraTrack,
    localCameraEnabled,
    localMicrophoneEnabled,
  } = useLocalPlayer()

  const movieIconSize = useBreakpointValue({ base: '32px', lg: '64px' })

  const badgeFontSize = useBreakpointValue({ base: 'sm', lg: 'md' })
  const badgeIconSize = useBreakpointValue({ base: '12px', lg: '14px' })

  if (roomStatus === 'left') {
    return null
  }

  return (
    <Box w="full" h="full" pos="relative">
      <SpeakerIndicator
        audioTrack={audioTrack}
        enabled={localMicrophoneEnabled}
      />

      <Box h="full" w="full" bg="gray.700" pos="relative" borderRadius="sm">
        {localCameraEnabled ? (
          <Flex
            direction="column"
            justify="flex-end"
            boxSize="full"
            transform="scaleX(-1)"
          >
            <LocalVideoTrack
              track={cameraTrack}
              disabled={!localCameraEnabled}
              play
              style={{
                width: '100%',
                height: '100%',
                // ミラーになるように
                transform: 'scaleX(-1)',
              }}
            />
          </Flex>
        ) : (
          <Center flexDirection="column" color="white" w="full" h="full">
            <CameraOff size={isSmall ? '32px' : movieIconSize} />
          </Center>
        )}
        {!hideBadge && (
          <Badge
            pos="absolute"
            left="8px"
            bottom="8px"
            px="2"
            bg="gray.500"
            color="white"
            fontWeight="normal"
            fontSize={isSmall ? 'sm' : badgeFontSize}
          >
            <HStack>
              <Text>あなた</Text>
              {localMicrophoneEnabled ? (
                <MicOn size={isSmall ? '12px' : badgeIconSize} />
              ) : (
                <MicOff size={isSmall ? '12px' : badgeIconSize} />
              )}
            </HStack>
          </Badge>
        )}
      </Box>
    </Box>
  )
}
